import Api from "shared/service/api/api";

//actions
export const LOAD_PAYOUT_LIST = "loadPayoutList";

//mutations
export const SET_PAYOUT_LIST = "setPayoutList";

const state = {
  payouts: {
    list: [],
    page: 1,
    page_count: 1,
  },
};

const actions = {
  [LOAD_PAYOUT_LIST]({ commit }, { page }) {
    Api.admin.payout
      .all(page)
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_PAYOUT_LIST, response.data);
      })
      .catch((e) => e);
  },
};

const mutations = {
  [SET_PAYOUT_LIST](state, { list, page, page_count }) {
    state.payouts.list = list.map((request) => {
      request.full_name = request.first_name + " " + request.last_name;
      return request;
    });
    state.payouts.page = page;
    state.payouts.page_count = page_count;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
